<template>
    <div>
        <div class="p-6 border border-solid flex flex-col md:w-1/2 mt-6">
            <h4>Data Transfer</h4>
            <p>This is your data transfer allowance for the calendar month. Exceeding this limit will result in additional charges.</p>
            <b-progress :max="limitGb" height="2rem" :variant="barVarient">
                <b-progress-bar :value="usageGb">
                    <span class="sau-font-bold font-bold ml-2"><strong>{{ usageGb.toFixed(2) }} GB / {{ limitGb }} GB</strong></span>
                </b-progress-bar>
            </b-progress>
            <p v-if="exceededLimit" class="text-sm sau-font-bold">You have exceeded your data transfer allowance for the calendar month. Current excess usage charge {{ excessCharges | currency }}.</p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        service: {
            required: true,
        }
    },

    computed: {
        usageGb() {
            return this.service.usage / 1000;
        },
        limitGb() {
            return this.service.limit / 1000;
        },
        barVarient() {
            if(this.usageGb >= this.limitGb) {
                return 'danger';
            } else if(this.usageGb / this.limitGb >= 0.8) {
                return 'orange';
            } else {
                return 'primary';
            }
        },
        exceededLimit() {
            return this.service.usage > this.service.limit;
        },
        excessCharges() {
            const excessRate = this.service.overage.rate;
            const excessAmount = this.usageGb - this.limitGb;
            return excessRate * excessAmount;
        }
    }
}
</script>